import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { LayoutListItemProps, LayoutListVariant } from './LayoutList.types';

export const LayoutListItem: React.FC<{
  item: LayoutListItemProps;
  onItemClicked: (item: LayoutListItemProps) => void;
  variant?: 'default' | 'superAdminOnly';
}> = ({ item, onItemClicked, variant }) => {
  const Icon = item.icon;
  return (
    <Flex
      _hover={{
        backgroundColor: 'mono2',
        transition: 'all',
      }}
      _active={{
        backgroundColor: 'mono3',
        transition: 'all',
      }}
      paddingX={16}
      cursor={'pointer'}
      paddingY={20}
      border={'1px solid'}
      borderColor={'mono3'}
      borderRadius={12}
      width={'100%'}
      alignItems={'flex-start'}
      gap={16}
      onClick={() => onItemClicked(item)}
      role="group"
    >
      <Flex
        height={24}
        width={24}
        justifyContent="center"
        alignItems="center"
      >
        <Icon
          size={16}
          color={variant === LayoutListVariant.SUPER_ADMIN_ONLY ? '#4951EF' : 'mono14'}
          _groupHover={{ color: 'linkHover' }}
          _groupActive={{ color: 'linkActive' }}
        />
      </Flex>
      <Flex flexDirection={'column'}>
        <TextV2
          typographyVariant={'hed2'}
          color={variant === LayoutListVariant.SUPER_ADMIN_ONLY ? '#4951EF' : 'mono14'}
          _groupHover={{ color: 'linkHover' }}
          _groupActive={{ color: 'linkActive' }}
        >
          {item.title}
        </TextV2>
        <TextV2
          typographyVariant={'body1'}
          color={'mono10'}
          _groupHover={{ color: 'linkHover' }}
          _groupActive={{ color: 'linkActive' }}
          marginTop={3}
        >
          {item.subtitle}
        </TextV2>
      </Flex>
    </Flex>
  );
};
